import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVEntry, RichText } from '@uswitch/ev-core/react';
import Breadcrumbs from '../../elements/breadcrumbs';
import Billboard from './billboard';
import { ContentfulModules, moduleEntity } from '../../helpers/modules';
import { useEntity, useDataSelector } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var BillboardConnected = function BillboardConnected(_ref) {
  var _imageEntity$file;

  var breadcrumbs = _ref.breadcrumbs,
      primaryContent = _ref.primaryContent,
      primarySlot = _ref.primarySlot,
      fullWidthSlot = _ref.fullWidthSlot,
      image = _ref.image,
      showImageOnMobile = _ref.showImageOnMobile,
      palette = _ref.palette;
  var primarySlotEntity = useEntity(primarySlot);
  var fullWidthSlotEntities = useEntity(fullWidthSlot);
  var crumbs = useDataSelector(['breadcrumb']);

  var breadcrumbsComponent = breadcrumbs && _jsx(Breadcrumbs, {
    crumbs: crumbs,
    variant: "light"
  });

  var primaryContentComponent = primaryContent && _jsx(RichText, {
    content: primaryContent
  });

  var primarySlotComponent = primarySlot && _jsx(EVEntry, _objectSpread({}, moduleEntity(primarySlotEntity)));

  var fullWidthSlotComponent = fullWidthSlot && _jsx(ContentfulModules, {
    modules: fullWidthSlotEntities
  });

  var imageEntity = useEntity(image);
  return _jsx(Billboard, {
    breadcrumbs: breadcrumbsComponent,
    primaryContent: primaryContentComponent,
    primarySlot: primarySlotComponent,
    fullWidthSlot: fullWidthSlotComponent,
    bgImage: imageEntity === null || imageEntity === void 0 ? void 0 : (_imageEntity$file = imageEntity.file) === null || _imageEntity$file === void 0 ? void 0 : _imageEntity$file.url,
    showImageOnMobile: showImageOnMobile,
    palette: palette
  });
};

export default BillboardConnected;
//# sourceMappingURL=index.js.map